import { DeterministicView } from '@bingads-webui/deterministic-view';

/**
 * Deterministic view for html content,
 *  generate deterministic view for input backbone view,
 *  so it can be used in the deterministic-only packages
 */
export class DeterministicViewForHtml extends DeterministicView {
  initialize({ html }) {
    this.setState({ html });
  }

  template() {
    return this.model.get('html');
  }
}
